import { ASSETS, CONTACT } from "../lib/brand";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-white text-black pt-20 md:pt-28 pb-10"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10 md:gap-16 pb-16 md:pb-20">
          <div className="col-span-12 md:col-span-5">
            <img
              src={ASSETS.logo}
              alt="The Prismatics Co."
              data-testid="footer-logo"
              className="w-40 md:w-52 h-auto object-contain"
              loading="lazy"
            />
            <p className="font-body text-sm leading-[1.85] text-black/70 mt-8 max-w-sm">
              A curated camera rental house. Based in KW, available beyond —
              trusted by storytellers who care about the keeping.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3 md:col-start-7">
            <div className="label-eyebrow mb-5">Visit</div>
            <ul className="space-y-2 font-body text-sm">
              <li><a href="#top" className="link-underline" data-testid="footer-nav-top">Top</a></li>
              <li><a href="#occasions" className="link-underline" data-testid="footer-nav-occasions">Occasions</a></li>
              <li><a href="#rentals" className="link-underline" data-testid="footer-nav-rentals">Rentals</a></li>
              <li><a href="#reviews" className="link-underline" data-testid="footer-nav-reviews">Reviews</a></li>
              <li><a href="#editorial" className="link-underline" data-testid="footer-nav-editorial">Editorial</a></li>
              <li><a href="#book" className="link-underline" data-testid="footer-nav-book">How to book</a></li>
              <li><a href="#terms" className="link-underline" data-testid="footer-nav-terms">Terms</a></li>
              <li><a href="#feed" className="link-underline" data-testid="footer-nav-feed">Feed</a></li>
              <li><a href="#contact" className="link-underline" data-testid="footer-nav-contact">Contact</a></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="label-eyebrow mb-5">Elsewhere</div>
            <ul className="space-y-2 font-body text-sm">
              <li>
                <a
                  href={CONTACT.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-underline"
                  data-testid="footer-social-instagram"
                >Instagram</a>
              </li>
              <li>
                <a
                  href={CONTACT.social.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-underline"
                  data-testid="footer-social-tiktok"
                >TikTok</a>
              </li>
              <li>
                <a
                  href={CONTACT.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-underline"
                  data-testid="footer-social-facebook"
                >Facebook</a>
              </li>
              <li className="pt-4">
                <a href={`mailto:${CONTACT.email}`} className="link-underline" data-testid="footer-email-link">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={CONTACT.phoneHref} className="link-underline" data-testid="footer-phone-link">
                  {CONTACT.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="border-t border-black pt-10 md:pt-14 pb-6 overflow-hidden">
          <div
            data-testid="footer-wordmark"
            className="font-display tracking-[-0.035em] leading-[0.85] text-[16vw] md:text-[14.5vw] whitespace-nowrap"
          >
            <span className="italic font-normal text-[4vw] md:text-[3.2vw] align-top mr-4">The</span>
            PRISMATICS<span className="italic font-normal"> Co.</span>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-6 border-t border-black/10">
          <span className="label-micro opacity-60">
            © {new Date().getFullYear()} The Prismatics Co. All rights reserved.
          </span>
          <span className="label-micro opacity-60 italic font-normal font-display">
            your world through our lenses.
          </span>
        </div>
      </div>
    </footer>
  );
};
